import React from 'react';

import DossierTeaser from './Teaser';
import DossierFull from './Full';

const Dossier = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <DossierTeaser {...props} />;
  }

  return <DossierFull {...props} />;
};

export default Dossier;
